module.exports = __webpack_public_path__ + "img/appleBtn2.6589f414.png";